module.exports = __webpack_public_path__ + "img/理赔案例1.afc51a03.jpg";